/** Checkout / order-request currency display (`$10`, `$10.50`). */
export function formatCheckoutCurrency(amount: number): string {
  if (!Number.isFinite(amount)) {
    return '$0';
  }
  const rounded = Math.round(amount * 100) / 100;
  if (Math.abs(rounded - Math.round(rounded)) < 0.001) {
    return `$${Math.round(rounded)}`;
  }
  return `$${rounded.toFixed(2)}`;
}
